import React, { forwardRef } from 'react';

interface ButtonProps {
  variant?: string;
  size?: 'sm' | 'lg';
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
  'aria-label'?: string;
  title?: string;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({ variant = 'primary', size, disabled, type = 'button', className = '', onClick, children, ...rest }, ref) {
    const variantMap: Record<string, string> = {
      primary: 'btn-primary',
      secondary: 'btn-secondary',
      danger: 'btn-error',
      link: 'btn-link',
      'outline-primary': 'btn-outline btn-primary',
      'outline-danger': 'btn-outline btn-error',
    };
    const variantClass = variantMap[variant] || '';
    const sizeClass = size ? `btn-${size}` : '';
    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        className={`btn ${variantClass} ${sizeClass} ${className}`.trim()}
        onClick={onClick}
        {...rest}
      >
        {children}
      </button>
    );
  }
);

export default Button;
